
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-info_svg__clip0_1716_18235)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M12-.001c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 21.818c-5.414 0-9.818-4.404-9.818-9.818S6.586 2.181 12 2.181s9.818 4.404 9.818 9.818-4.404 9.818-9.818 9.818z"}}),_c('path',{attrs:{"d":"M12 5.09c-.802 0-1.454.653-1.454 1.455S11.198 7.999 12 7.999a1.456 1.456 0 000-2.91z"}}),_c('path',{attrs:{"d":"M12 10.18a1.09 1.09 0 00-1.09 1.092v6.545a1.09 1.09 0 102.18 0v-6.545A1.09 1.09 0 0012 10.18z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-info_svg__clip0_1716_18235"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 -.001)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    